import request from "@/service";

/* 查询考核规则列表 */
export function examRuleList(data) {
  return request({
    url: `/user/exam/rule/pageNew`,
    method: "get",
    params: data
  });
}

/* 查询该考核规则 */
export function examRuleInfo(data) {
  return request({
    url: `/user/exam/rule/infoNew`,
    method: "post",
    data
  });
}

/* 新增考核规则 */
export function examRuleSave(data) {
  return request({
    url: `/user/exam/rule/saveNew`,
    method: "post",
    data
  });
}

/* 更新考核规则信息 */
export function examRuleUpdate(data) {
  return request({
    url: `/user/exam/rule/updateNew`,
    method: "put",
    data
  });
}

/* 批量删除考核规则 */
export function examRuleDelete(data) {
  return request({
    url: `/user/exam/rule/deleteNew`,
    method: "delete",
    data
  });
}

export function examRuleEnable(data) {
  return request({
    url: `/user/exam/rule/enable`,
    method: "post",
    data
  });
}

/* 查询管理类别 */
export function getUserLeaderType(params) {
  return request({
    url: `/user/exam/rule/getUserLeaderType`,
    method: "get",
    params
  });
}


export function queryDeptRule(data) {
  return request({
    url: `/user/exam/rule/queryInfo`,
    method: "post",
    data
  });
}


